export default __webpack_public_path__ + "static/pipeline-0343a9639e74b4b94636206dedebdb12.jpg";